module.exports = __webpack_public_path__ + "static/media/logout.e6b2f082.svg";